export default __webpack_public_path__ + "static/media/pic1.a3008e19.jpg";